export default __webpack_public_path__ + "static/logo-3b78150b3a1e9627ff334233aae997b5.png";